import { Link } from "@/i18n/navigation";
import Image from "next/image";

function pushCtaClickDataLayer(dataLayerPayload, cta_button) {
  if (typeof window === "undefined" || !dataLayerPayload) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ...dataLayerPayload,
    cta_button: cta_button ?? "",
  });
}

/* 
    example data: 
    
    {
    "Code": 57,
    "Name": "Pamukkale Turizm",
    "Slug": "pamukkale-turizm",
    "RedirectUrl": "/otobus-bileti/pamukkale-turizm",
    "ImageUrl": "https://res.cloudinary.com/turna/image/upload/q_auto,f_auto/v2/Images/Bus/BusCompanies/pamukkale-turizm.png",
    "AnchorTitle": "Pamukkale Turizm Otobüs Bileti"
  },

*/

export default function BrandCard({ brand, dataLayerPayload = null }) {
  const handleClick = () => {
    if (dataLayerPayload) {
      pushCtaClickDataLayer(dataLayerPayload, brand?.Name);
    }
  };

  return (
    <Link
      href={brand?.RedirectUrl || "/"}
      className="flex w-full flex-col items-center justify-center gap-3 overflow-hidden"
      onClick={handleClick}
    >
      <div className="border-border-card bg-background-global relative flex h-[134px] w-full items-center justify-center rounded-lg border">
        <div className="relative h-[52px] w-[110px]">
          <Image
            src={brand?.SvgImageUrl || brand?.ImageUrl || ""}
            alt={brand?.AnchorTitle || brand?.Name || "brand-image"}
            fill
            className="object-contain"
          />
        </div>
      </div>
      <div>
        <p className="text-base font-medium">{brand?.Name}</p>
      </div>
    </Link>
  );
}
